<template>
    <!-- 手机CARD部 -->
    <div class="md:hidden" v-loading="loading" :style="{'height': isStandalone ? 'calc(100vh - 242px)' : 'auto'}">
        <div v-if="!isStandalone" class="flex flex-wrap gap-4">
            <el-card style="width: 100%; border: 2px solid #d1d5db; border-radius: 10px"
                v-for="item in (!isStandalone ? tableData : data)" :key="item.inventory_id">
                <el-row align="middle">
                    <el-col :span="3">
                        <div>
                            <span v-if="!item.isExpand" class="material-symbols-outlined cursor-pointer" @click="handleExpandButton(item)">
                                <el-icon :size="16">
                                    <ArrowDown />
                                </el-icon>
                            </span>
                            <span v-else class="material-symbols-outlined cursor-pointer" @click="handleCollapseButton(item)">
                                <el-icon :size="16">
                                    <ArrowUp />
                                </el-icon>
                            </span>
                        </div>
                    </el-col>

                    <el-col :span="15">
                        <div>{{ item.department_name }}</div>
                    </el-col>

                    <el-col :span="5">
                        <div class="flex justify-end items-baseline">
                            <span class="text-xl">{{ item.quantity }}</span>
                            <span v-if="item.material_unit" class="text-sm text-gray-500 ml-1">{{ item.material_unit }}</span>
                        </div>
                    </el-col>

                    <el-col :span="1">
                        <span class="material-symbols-outlined cursor-pointer mt-1.5"
                            @click="handleSetConstantButton(item)">
                            settings
                        </span>
                    </el-col>
                </el-row>
                    
                <div v-if="item.isExpand" class="mt-2">
                    <div v-if="item.details && item.details.length > 0" class="expand-content">
                        <!-- 使用DetailLevelInventoryList组件显示详细库存信息 -->
                        <DetailLevelInventoryList
                            :data="item.details"
                            :loading="false"
                            :is-standalone="false"
                            @edit="$emit('edit', $event)"
                            @delete="$emit('delete', $event)"
                            @alarm="$emit('alarm', $event)"
                            @transfer-inventory="$emit('transferInventory', $event)"
                            @quantity-update="$emit('quantityUpdate', $event)"
                        />
                    </div>
                    <div v-else class="expand-content text-gray-500">
                        データを読み込み中...
                    </div>
                </div>
            </el-card>
        </div>

        <div v-else style="overflow-y: auto; height: calc(100vh - 242px)">
            <div class="flex flex-wrap gap-4 p-4">
                <el-card style="width: 100%; border: 2px solid #d1d5db; border-radius: 10px"
                    v-for="item in (!isStandalone ? tableData : data)" :key="item.inventory_id">
                    <div class="flex flex-col justify-between">
                        <div class="flex justify-between">
                            <div>{{ item.organization_name }}</div>
                            <span class="material-symbols-outlined cursor-pointer"
                                @click="handleSetConstantButton(item)">
                                settings
                            </span>
                        </div>
                        <div>{{ item.department_name }}</div>
                    </div>

                    <div class="flex flex-col justify-between">
                        <div>{{ item.material_name }}</div>
                        <div>{{ item.category_name }}</div>
                    </div>

                    <el-row align="middle">
                        <el-col :span="10" justify="center">
                            <div>在庫合計</div>
                            <div class="flex justify-center items-baseline">
                                <span class="text-5xl">{{ item.quantity }}</span>
                                <span v-if="item.material_unit" class="text-sm text-gray-500 ml-1">{{ item.material_unit }}</span>
                            </div>
                            <div class="flex justify-center">
                                <span v-if="!item.isExpand" class="material-symbols-outlined cursor-pointer" @click="handleExpandButton(item)">
                                    <el-icon :size="16">
                                        <ArrowDown />
                                    </el-icon>
                                </span>
                                <span v-else class="material-symbols-outlined cursor-pointer" @click="handleCollapseButton(item)">
                                    <el-icon :size="16">
                                        <ArrowUp />
                                    </el-icon>
                                </span>
                            </div>
                        </el-col>

                        <el-col :span="14">
                            <div class="h-[120px]" align="center">
                                <ImgLoading v-if="item.images" v-model="item.images" class="carousel-image" />
                                <div v-else class="w-full h-full bg-gray-100"></div>
                            </div>
                        </el-col>
                    </el-row>
                        
                    <div v-if="item.isExpand" class="mt-2">
                        <div v-if="item.details && item.details.length > 0" class="expand-content">
                            <!-- 使用DetailLevelInventoryList组件显示详细库存信息 -->
                            <DetailLevelInventoryList
                                :data="item.details"
                                :loading="false"
                                :is-standalone="false"
                                @edit="$emit('edit', $event)"
                                @delete="$emit('delete', $event)"
                                @alarm="$emit('alarm', $event)"
                                @transfer-inventory="$emit('transferInventory', $event)"
                                @quantity-update="$emit('quantityUpdate', $event)"
                            />
                        </div>
                        <div v-else class="expand-content text-gray-500">
                            データを読み込み中...
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>

    <!-- 表格模式 -->
    <div class="hidden md:block w-full" :class="{ 'nested-table': !isStandalone }">
        <el-table 
            ref="tableRef"
            :data="(!isStandalone ? tableData : data)" 
            :height="tableHeight"
            v-loading="loading" 
            row-key="inventory_id"
            :show-header="isStandalone"
            @expand-change="handleExpandChange">
            <!-- 展开列 -->
            <el-table-column type="expand" label="詳細" width="80" align="center">
                <template #default="props">
                    <div v-if="props.row.details && props.row.details.length > 0" class="expand-content">
                        <!-- 使用DetailLevelInventoryList组件显示详细库存信息 -->
                        <DetailLevelInventoryList
                            :data="props.row.details"
                            :loading="false"
                            :is-standalone="false"
                            @edit="$emit('edit', $event)"
                            @delete="$emit('delete', $event)"
                            @alarm="$emit('alarm', $event)"
                            @transfer-inventory="$emit('transferInventory', $event)"
                            @quantity-update="$emit('quantityUpdate', $event)"
                        />
                    </div>
                    <div v-else class="expand-content text-gray-500">
                        データを読み込み中...
                    </div>
                </template>
            </el-table-column>

            <!-- 组织名称列（仅在独立使用时显示） -->
            <el-table-column v-if="isStandalone" prop="organization_name" label="所属組織" width="200">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('organization_name')">
                        <span>{{ getSortLabel('organization_name') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'organization_name' }">
                                {{ getSortIcon('organization_name') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
                <template #default="scope">
                    <div class="flex items-center">
                        <span>{{ scope.row.organization_name }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- 主要列 - 简化为与组织级别一致的风格 -->
            <el-table-column prop="department_name" label="所属部門" width="200">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('department_name')">
                        <span>{{ getSortLabel('department_name') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'department_name' }">
                                {{ getSortIcon('department_name') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
                <template #default="scope">
                    <div class="flex items-center">
                        <span :class="indentClass">{{ scope.row.department_name }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="isStandalone" prop="category_name" label="カテゴリ" width="160">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('category_name')">
                        <span>{{ getSortLabel('category_name') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'category_name' }">
                                {{ getSortIcon('category_name') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
            </el-table-column>
            
            <el-table-column v-if="isStandalone" prop="material_name" label="アイテム名" min-width="400">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('material_name')">
                        <span>{{ getSortLabel('material_name') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'material_name' }">
                                {{ getSortIcon('material_name') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
                <template #default="scope">
                    <div>
                        {{ scope.row.material_name }}<br />
                        <span v-if="scope.row.jancode" class="text-sm text-gray-500">
                            （{{ scope.row.jancode }}）
                        </span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column v-if="!isStandalone" prop="blank" />
            <el-table-column v-if="!isStandalone" prop="blank" />

            <el-table-column prop="quantity" label="在庫数" width="100" header-align="center" align="right">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('quantity')">
                        <span>{{ getSortLabel('quantity') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'quantity' }">
                                {{ getSortIcon('quantity') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
                <template #default="scope">
                    <span>{{ scope.row.quantity }}</span>
                    <span v-if="scope.row.material_unit" class="text-sm text-gray-500 ml-1">{{ scope.row.material_unit }}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="操作" width="100" header-align="center" align="center">
                <template #default="scope">
                    <el-button
                        type="info"
                        style="background-color: #b7b7b7;"
                        text
                        bg
                        @click="handleSetConstantButton(scope.row)">
                        <span>定数設定</span>
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column v-if="isStandalone" prop="" label="画像" width="52" align="center">
                <template #default="scope">
                    <ImgLoading v-if="scope.row.images" :model-value="scope.row.images" class="thumbnail" />
                </template>
            </el-table-column>
            <!-- 空列（仅在独立使用时显示） -->
            <el-table-column v-if="!isStandalone" prop="blank" width="18" />
        </el-table>

    </div>

    <!-- 分页组件 -->
    <div v-if="!isStandalone && data.length > INVENTORY_CONSTANTS.DEPARTMENT_LEVEL.PAGE_SIZE" class="flex w-full flex-col md:flex-row md:justify-between mt-4">
        <div class="md:ml-6">
            <div v-if="data.length > INVENTORY_CONSTANTS.DEPARTMENT_LEVEL.EXCEED_RANGE" class="flex items-center">
                <el-icon color="#E6A23C" :size="24">
                    <WarnTriangleFilled />
                </el-icon>
                <span>部門の検索結果が{{ INVENTORY_CONSTANTS.DEPARTMENT_LEVEL.EXCEED_RANGE }}件を超えています。</span>
            </div>
        </div>

        <div>
            <div class="hidden md:flex items-center mb-4">
                <div class="mr-5">部門総計 {{ data.length }} 件</div>
                <el-pagination 
                    v-model:current-page="itemCurrentPage" 
                    v-model:page-size="itemPageSize"
                    layout="prev, pager, next"
                    :total="data.length" 
                    @size-change="handleItemSizeChange" 
                    @current-change="handleItemCurrentChange" 
                />
            </div>

            <div class="md:hidden flex justify-end">
                <el-pagination 
                    v-model:page-size="itemPageSize"
                    layout="prev, pager, next" 
                    :total="data.length"
                    @current-change="handleItemCurrentChange" 
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, nextTick, computed, PropType, onMounted } from 'vue';
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue';
import moment from 'moment';
import { ROLES, INVENTORY_CONSTANTS } from '@/config/constants';
import ImgLoading from '@/components/common/ImgLoading.vue';
import CarouselLoading from '@/components/common/CarouselLoading.vue';
import AlertStatusIndicators from './AlertStatusIndicators.vue';
import DetailLevelInventoryList from './DetailLevelInventoryList.vue';
import { AlarmInfo, ConstantInfo, InventoryInfo } from './type';
import { WarnTriangleFilled } from '@element-plus/icons-vue';

export default defineComponent({
    name: 'DepartmentLevelInventoryList',
    components: {
        ArrowDown,
        ArrowUp,
        ImgLoading,
        CarouselLoading,
        AlertStatusIndicators,
        DetailLevelInventoryList,
        WarnTriangleFilled,
    },
    props: {
        data: {
            type: Array as PropType<InventoryInfo[]>,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loginUserRole: {
            type: String,
            required: true,
        },
        loginUserRoleIsHead: {
            type: Boolean,
            required: true,
        },
        searchDepartmentId: {
            type: String,
            default: null,
        },
        isStandalone: {
            type: Boolean,
            default: false, // 默认不是独立使用（嵌套使用）
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        pageSize: {
            type: Number,
            default: 10,
        },
        totalRecords: {
            type: Number,
            default: 0,
        },
    },
    emits: ['edit', 'delete', 'alarm', 'expand', 'collapse', 'quantityUpdate', 'constant', 'sort', 'size-change', 'current-change', 'transferInventory' ],
    setup(props, { emit }) {
        const tableRef = ref();

        const tableData = ref<InventoryInfo[]>([]);
        const itemCurrentPage = ref<number>(1);
        const itemPageSize = ref<number>(INVENTORY_CONSTANTS.DEPARTMENT_LEVEL.PAGE_SIZE);

        // 排序相关状态
        const sortField = ref<string>('material_name'); // 当前排序字段
        const sortOrder = ref<'asc' | 'desc'>('asc'); // 当前排序方向

        // 排序配置
        const sortConfig = {
            'material_name': {
                label: 'アイテム名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'quantity': {
                label: '在庫数',
                type: 'number' as const,
                defaultOrder: 'desc' as const
            },
            'organization_name': {
                label: '組織',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'department_name': {
                label: '部門',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'category_name': {
                label: 'カテゴリ',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            }
        };

        onMounted(() => {
            if (!props.isStandalone) {
                tableData.value = props.data;
                calculatePagination();
            }
        });

        // 根据showHeader标志位计算表格高度
        const tableHeight = computed(() => {
            if (props.isStandalone) {
                // 显示表头时，使用固定高度撑满容器
                return 'calc(100vh - 260px)';
            } else {
                // 不显示表头时，使用自适应高度
                return 'auto';
            }
        });

        // 监听数据变化，重置展开状态
        watch(() => props.data, () => {
            // 当数据变化时，重置表格的展开状态
            if (tableRef.value) {
                // 使用nextTick确保DOM更新完成后再重置
                nextTick(() => {
                    // 清空所有展开的行
                    const expandedRows = tableRef.value.store.states.expandRows;
                    if (expandedRows && expandedRows.length > 0) {
                        expandedRows.forEach((row: any) => {
                            tableRef.value.toggleRowExpansion(row, false);
                        });
                    }
                });
            }
        }, { deep: true });

        // const handleExpandClick = (item: any) => {
        //     item.isExpand = true;
        //     emit('expand', item);
        // };

        // const handleCollapseClick = (item: any) => {
        //     item.isExpand = false;
        //     emit('collapse', item);
        // };

        const handleExpandChange = (row: any, expanded: boolean) => {
            if (expanded) {
                // 展开时触发获取数据
                emit('expand', row);
            } else {
                // 收起时触发收起事件
                emit('collapse', row);
            }
        };

        const handleExpandButton = (row: InventoryInfo) => {
            row.isExpand = true;
            handleExpandChange(row, true);
        };

        const handleCollapseButton = (row: InventoryInfo) => {
            row.isExpand = false;
            handleExpandChange(row, false);
        };

        const handleSetConstantButton = (row: any) => {
            emit('constant', row);
        };

        // 处理排序
        const handleSort = (field: string) => {
            if (sortField.value === field) {
                // 如果点击的是当前排序字段，切换排序方向
                sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
            } else {
                // 如果点击的是新字段，使用该字段的默认排序方向
                sortField.value = field;
                sortOrder.value = sortConfig[field as keyof typeof sortConfig]?.defaultOrder || 'asc';
            }
            // 触发排序事件，让父组件处理
            emit('sort', { field: sortField.value, order: sortOrder.value });
        };

        // 获取排序图标
        const getSortIcon = (field: string) => {
            if (sortField.value !== field) {
                return 'unfold_more'; // 未排序状态
            }
            return sortOrder.value === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        };

        // 获取排序字段的标签
        const getSortLabel = (field: string) => {
            const config = sortConfig[field as keyof typeof sortConfig];
            return config ? config.label : field;
        };

        // 分页处理方法
        const handleSizeChange = (size: number) => {
            emit('size-change', size);
        };

        const handleCurrentChange = (page: number) => {
            emit('current-change', page);
        };

        const indentClass = computed(() => {
            return props.isStandalone ? 'ml-4' : '';
        });

        const formatDate = (date: string) => {
            return moment(date).format('YYYY/MM/DD');
        };

        const isExpired = (date: string) => {
            return moment(date).isBefore(moment(), 'day');
        };

        const handleItemSizeChange = (size: number) => {
            itemPageSize.value = size;
            calculatePagination();
        };

        const handleItemCurrentChange = (page: number) => {
            itemCurrentPage.value = page;
            calculatePagination();
        };

        // 前端分页计算（支持多项目排序）
        const calculatePagination = () => {
            // 计算分页
            const startIndex = (itemCurrentPage.value - 1) * itemPageSize.value;
            const endIndex = startIndex + itemPageSize.value;
            
            tableData.value = props.data.slice(startIndex, endIndex);
        };

        return {
            tableRef,
            tableHeight,
            indentClass,
            formatDate,
            isExpired,
            handleExpandChange,
            handleExpandButton,
            handleCollapseButton,
            handleSetConstantButton,
            handleSort,
            getSortIcon,
            getSortLabel,
            handleSizeChange,
            handleCurrentChange,
            sortField,
            sortOrder,
            ROLES,
            INVENTORY_CONSTANTS,
            tableData,
            itemCurrentPage,
            itemPageSize,
            handleItemSizeChange,
            handleItemCurrentChange
        };
    },
});
</script>

<style scoped>
.thumbnail {
    width: 30px;
    height: 30px;
    object-fit: cover;
}

.carousel-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.custom-title {
    background-color: #f5f5f5;
    padding: 0 16px;
    border-bottom: 1px solid #ddd;
}

/* 排序表头样式 */
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}


.cursor-pointer {
    cursor: pointer;
}

.hover\:text-blue-600:hover {
    color: #2563eb;
}

.hover\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.big-font-input :deep(.el-input__inner) {
    font-size: 32px;
}

.quantity-editor {
    border-radius: 6px;
}

/* 覆盖展开单元格的默认内边距 */
/* :deep(.el-table__expanded-cell) {
    padding: 0 !important;
}

:deep(.el-table__expanded-cell .cell) {
    padding: 0 !important;
} */

:deep(.el-table__cell.el-table__expanded-cell) {
    padding: 0 !important;
}
</style> 